module.exports = __webpack_public_path__ + "static/media/024.31cd4af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/024.jpg
// module id = 497
// module chunks = 0